import { MoovConfigurationDTO } from "../DTO/moovConfigurationDTO";
import { BasicRequest } from "./basicRequest";

export class CreateMoovConfigurationRequest extends BasicRequest{
   
    public moovConfiguration! : MoovConfigurationDTO;
    
    constructor(){
        super();
    }
}